import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../service/service.module';
import { CLIENT_PREFERNCE_KEY, CLIENT_WEEK_START_DAY } from '@algomusinc/domain';
import { LocalstorageService } from './localstorage.service';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientPreferenceService {

  environment = EnvironmentService.environment;

  constructor(private http: HttpClient, public storage: LocalstorageService) {
  }

  getClientPreference() {
    return this.http.get<any>(`${this.environment.AppAccount}/getclientpreference`)
      .pipe(map((clientPreference: any) => {
        this.storage.set(CLIENT_PREFERNCE_KEY, JSON.stringify(clientPreference));
        return clientPreference;
      }));
  }

  getPreferenceByKey(preferenceKey: any) {
    const clientPreferences = JSON.parse(this.storage.get(CLIENT_PREFERNCE_KEY));
    const preference = _.find(clientPreferences, a => a.preferenceKey == preferenceKey);
    if (preference) {
      switch (preference.type) {
        case 'NUMBER': {
          return Number(preference.preferenceState);
        }
        case 'JSON': {
          return JSON.parse(preference.preferenceState);
        }
        case 'BOOLEAN': {
          return preference.preferenceState == '1' ? true : false;
        }
        default: {
          return preference.preferenceState;
        }
      }
    } else {
      return null;
    }
  }

  getClientPreferencebyId() {
    const clientPreference: any = [
      // {
      //   "clientPreferenceId": 2,
      //   "tenantId": 32,
      //   "preferenceKey": "CLIENT_WEEK_START_DAY",
      //   "preferenceState": "6",
      //   "createdById": 0,
      //   "createdDate": "0001-01-01T00:00:00",
      //   "modifiedById": null,
      //   "modifiedDate": null,
      //   "active": false,
      //   "type": "NUMBER"
      // }
    ];
    this.storage.set(CLIENT_PREFERNCE_KEY, JSON.stringify(clientPreference));
    return of(clientPreference);
  }

  getSamplePreferenceObject(preferenceKey: any) {
    return {
      preferenceKey: preferenceKey,
      preferenceState: null,
    };
  }

  getClientWeekStartDay(): number {
    const clientPreferences = JSON.parse(this.storage.get(CLIENT_PREFERNCE_KEY));
    const preference = _.find(clientPreferences, a => a.preferenceKey == CLIENT_WEEK_START_DAY);
    return preference ? Number(preference.preferenceState) : 0;
  }
}

